import {Map} from 'immutable';
import { Route } from "react-router-dom";
import {Roles} from '../config/Roles';
import { useEffect, useState } from 'react';
import { ApiConfiguration } from '../config/ApiConfiguration';
import { RouteKeys } from '../config/RouteKeys';

const routesToRoles = Map([
    [RouteKeys.INVITE, [Roles.ADMIN, Roles.GUEST]],
    [RouteKeys.STATISTICS, [Roles.ADMIN]],
]);

export const useAuthorization = (UnauthorizedElement) => {
    const [authorizedGuest, setAuthorizedGuest] = useState();
    const params = new URL(window.location.href).searchParams;
    const paramsGuestName = params.get('invited');
    useEffect(() => {
      fetch(...ApiConfiguration.authenticateGuest(paramsGuestName))
         .then(r => r.json())
         .then(setAuthorizedGuest);
    }, [paramsGuestName]);
    const isGuestEntitledToRoute = (guest, routeKey, AuthorizedElement) => {
      const element = guest && guest.entitlements.some(ent => (routesToRoles.get(routeKey) ?? []).includes(ent)) ? AuthorizedElement : UnauthorizedElement;
      return <Route path={routeKey} element={element}/>;
    };
  
    return {
      authorizedGuest,
      isGuestEntitledToRoute,
    };
};
  